/**
 * HR tab model.
 *
 * HR consolidates team members, sick leaves, vacation requests, work hours,
 * skills, shift patterns and (since issue #532) shift-end confirmation
 * review into a single page with URL-driven tabs (?tab=…). Unlike the
 * Calendar/Settings tab models, every HR tab is gated by the same single
 * `hr.view_team` permission (enforced at the route), so there's no per-tab
 * permission clamping — just a canonical tab list and a resolve-or-default
 * function to keep a crafted ?tab= value from landing on an unmatched
 * value (blank content).
 */

export type HrTab =
  | 'team-members'
  | 'sick-leaves'
  | 'vacation-requests'
  | 'work-hours'
  | 'skills'
  | 'shift-patterns'
  | 'shift-end-confirmations';

export const HR_TABS: HrTab[] = [
  'team-members',
  'sick-leaves',
  'vacation-requests',
  'work-hours',
  'skills',
  'shift-patterns',
  'shift-end-confirmations',
];

/**
 * Resolve a requested (URL) tab to a valid one, defaulting to 'team-members'
 * for a missing or unrecognized value.
 */
export function resolveHrTab(requested: string | null): HrTab {
  if (requested && (HR_TABS as string[]).includes(requested)) {
    return requested as HrTab;
  }
  return 'team-members';
}
